import React from "react";
import { Button, Modal } from "react-bootstrap";

import { DeleteLFPModalProps } from "../types/lookingforplayers";

const DeleteLFPModal = ({
    show,
    setShow,
    handleDelete,
}: DeleteLFPModalProps): React.JSX.Element => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            data-testid="deleteLFPModal"
            centered
        >
            <Modal.Header>
                <Modal.Title>Delete Looking For Players Request?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete this looking for players
                request?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => setShow(false)}>
                    No
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteLFPModal;
